export default __webpack_public_path__ + "static/media/lock.10068fe6.svg";